import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT


export const getList = (params) => {
  return axios.post(root + '/order/salecontractdiffrecord/list', qs.stringify(params))
}
export const getOrderList = (params) => {
  return axios.post(root + '/order/salecontractdiffrecord/orderlist', qs.stringify(params))
}
export const getBrandList = (params) => {
  return axios.post(root + '/order/salecontractdiffrecord/brandlist', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/order/salecontractdiffrecord/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/order/salecontractdiffrecord/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {
  if (params.unitguid) {//修改
    return axios.post(root + '/order/salecontractdiffrecord/update', qs.stringify(params))
  } else {//添加
    return axios.post(root + '/order/salecontractdiffrecord/save', qs.stringify(params))
  }
}




// WEBPACK FOOTER //
// ./src/api/order/salecontractdiffrecord.js